import authorizedAPIInstance from '@/api/authorizedAPI';
import type { ProductionOrder } from '../utils/types';
import { formatAPIError, replacePlaceholders } from '@/utils/helpers';

export type ProductionOrderInput = {
  productionOrderId: string;
};

export const fetchProductionOrderById = async ({
  productionOrderId,
}: ProductionOrderInput): Promise<ProductionOrder> => {
  try {
    const { data } = await authorizedAPIInstance.get<ProductionOrder>(
      replacePlaceholders(`/api/production-orders/:productionOrderId`, {
        productionOrderId,
      })
    );
    return data;
  } catch (error) {
    throw formatAPIError(error);
  }
};
